export default "__VITE_ASSET__GFYgQ53D__"